import { useApiGet } from "@/hooks/useApi";
import { getAllCourses } from "../api";

export function useGetAllCourses() {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["courses", "list", "all"],
		fn: getAllCourses,
		// The catalogue backs the public marketing page; a 500 must not pop a
		// Bosnian error toast over it. Components render the empty state.
		suppressErrorRedirect: true,
	});

	const { courses, categories } = data || { courses: [], categories: [] };

	return { courses, categories, isPending, isSuccess, isError, error };
}
